export {
  isCouponProduct,
  ITS_PRODUCT_ID,
  type Product,
  PRODUCT_ID_MAP_VARIANTS,
  PRODUCT_MAP_VARIANTS,
  PRODUCT_NAME,
  type SubProduct,
} from './Product.js';
